require('./autocomplete.css');

export let autocomplete:any[] = ['service', (service) => {
    class AutocompleteDirective {
        restrict = 'A';
        require = 'ngModel';
        scope = {
            searchString: '=ngModel',
            properties: '=autocomplete',
            context: '='
        };


        link(scope, element, attr, model) {
            var properties = {
                labelField: 'label',
                delay: 300,
                searchOnFocus: false,
                minLength: 2,
                paramsCallback: null,
                url: null,
                valueField: null,
                value: null,
                errorCallback: null,
                selectCallback: null,
                responseCallback: null,
                itemClass: null,
            };
            if (scope.properties) {
                _.extend(properties, scope.properties);
            }

            element.autocomplete({
                delay: properties.delay || 300,
                minLength: properties.searchOnFocus ? 0 : properties.minLength || 3,
                position: {
                    my: "left top+10",
                    at: "left bottom",
                    collision: "flip"
                },
                source: function (request, response) {
                    let params = {value: request.term};

                    if (!!properties.paramsCallback)
                        properties.paramsCallback(params);

                    service.apiPost(properties.url, params)
                        .then(
                            (data)=> {
                                let result = [];
                                angular.forEach(data.value, function (item) {
                                    let listItem = {
                                        label: typeof item === 'object' ? item[properties.labelField] : item,
                                        object: item,
                                        value: null
                                    };

                                    if (!!properties.valueField)
                                        listItem.value = item[properties.valueField];

                                    result.push(listItem);
                                });
                                response(result);
                            },
                            (result)=> {
                                if (properties.errorCallback)
                                    properties.errorCallback(result);
                            }
                        )
                },
                select: (event, ui)=> {
                    model.$setViewValue(ui.item.label);

                    if (properties.selectCallback)
                        properties.selectCallback(ui.item.object, scope.context);

                    scope.$apply();
                },
                response: (event, ui)=> {
                    if (properties.responseCallback)
                        properties.responseCallback(ui.content, scope.context);
                }
            });

            if (properties.itemClass) {
                element.data("ui-autocomplete")._renderItem = function (ul, item) {
                    let itemClass = properties.itemClass(item);
                    return $("<li>").append(item.label).appendTo(ul).addClass(itemClass);
                };
            }

            if (properties.searchOnFocus) {
                element.click(function () {
                    $(this).autocomplete('search', $(this).val())
                });
            }
        }
    }

    return new AutocompleteDirective();
}];


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/autocomplete.directive.ts